import React from "react";
import "../styles/Media.css";
import FadeInSection from "./FadeInSection";
import { FaSteam } from "react-icons/fa";
import { SiLetterboxd, SiGithub, SiRoblox, SiYoutube } from "react-icons/si";

const FAVORITE_GIFS = [
  // Add your gifs here:
  // { src: "https://giphy.com/gifs/help-heart-need-AXOdttXiL8MeI", alt: "Woof woof" },
  { src: "https://giphy.com/gifs/woofwaggers-help-halp-dog-jRxG53CYEWk9qG6s15", alt: "Woof HALP >-<" },
  { src: "https://giphy.com/gifs/CoolCats-cartoon-cool-coffee-M9Glh4EejjKOo3EMF0", alt: "(˵˃ ᗜ ˂˵)" },
  { src: "https://giphy.com/gifs/dobbiapparel-funny-lol-nyc-u7A8q8nbNuJqcGCeU6", alt: "Monkey Business" },
];

const toDisplayableGifUrl = (url) => {
  if (!url) return url;

  // Convert Giphy page links to direct gif files for <img src>.
  const giphyMatch = url.match(/giphy\.com\/gifs\/(?:.+-)?([A-Za-z0-9]+)$/);
  if (giphyMatch) {
    return `https://media.giphy.com/media/${giphyMatch[1]}/giphy.gif`;
  }

  return url;
};


const MEDIA_LINKS = [
  {
    href: "https://github.com/new-cmd",
    label: "GitHub",
    Icon: SiGithub,
  },
  {
    href: "https://steamcommunity.com/id/_shy/",
    label: "Steam",
    Icon: FaSteam,
  },
  {
    href: "https://letterboxd.com/shymovies/",
    label: "Letterboxd",
    Icon: SiLetterboxd,
  },
  {
    href: "https://www.youtube.com/watch?v=g5B9BOQ07II&list=PLPWD7LGRDq1dXpulhyc0rfYczY2owa5X7",
    label: "YouTube",
    Icon: SiYoutube,
  },
  {
    href: "https://www.roblox.com/users/6158818918/profile",
    label: "Roblox",
    Icon: SiRoblox,
  },
];

class Media extends React.Component {
  render() {
    return (
      <div id="media">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">/ media</span>
          </div>
          <ul className="media-links">
            {MEDIA_LINKS.map(({ href, label, Icon }) => (
              <li key={label}>
                <a
                  href={href}
                  className="media-links__item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon className="media-links__icon" aria-hidden />
                  <span>{label}</span>
                </a>
              </li>
            ))}
          </ul>
          <div id="favorite-gifs" className="favorite-gifs">
            <div className="section-header ">
              <span className="section-title">/ favorite gifs</span>
            </div>
            {FAVORITE_GIFS.length === 0 ? (
              <p className="favorite-gifs__empty">
                Add GIF URLs in <code>FAVORITE_GIFS</code> inside{" "}
                <code>Media.js</code>.
              </p>
            ) : (
              <div className="favorite-gifs__grid">
                {FAVORITE_GIFS.map(({ src, alt }) => (
                  <figure className="favorite-gifs__item" key={src}>
                    <img src={toDisplayableGifUrl(src)} alt={alt} loading="lazy" />
                    <figcaption>{alt}</figcaption>
                  </figure>
                ))}
              </div>
            )}
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default Media;
